export default {
  pins: state => state.pins,
  // Every proposition id flagged as outside wishes by the pins response, so
  // the marker cards can show the "Närliggande förslag" tag (the swap-details
  // endpoint the cards are fed from does not carry the flag).
  outsideWishesIds: state =>
    new Set(state.pins.flatMap(pin => pin.outsideIds || [])),
  // Same for super interest: only the triangle details carry
  // hasSuperInterest, the pins' `s` ids cover direct swaps too.
  superInterestIds: state =>
    new Set(state.pins.flatMap(pin => pin.superIds || [])),
  selectedPinId: state => state.selectedPinId,
  hoveredPropositionId: state => state.hoveredPropositionId,
  selectedSuggestion: state => state.selectedSuggestion,
  selectedSuggestions: state => state.selectedSuggestions,
  loadingPins: state => state.loadingPins,
  loadingSuggestion: state => state.loadingSuggestion
};
